export const RegistryAPI = {
  async list(type?: string) {
    const url = type ? `/api/registry?type=${type}` : '/api/registry';
    const res = await fetch(url);
    if (!res.ok) throw new Error(`Registry fetch failed ${res.status}`);
    return res.json();
  }
};
